import React from 'react';
import Webcam from "react-webcam";
  
function Australia() {
    return (
      <div className="App">
        <a
          className="App-link"
          href="/"
          rel="noopener noreferrer"
          style={{fontSize: 26}}
        >
          <b>Home</b>
        </a>
        <header className="App-header">
          Thank you for your patience.<br />
          Our developers are hard at work to provide this service to you ASAP!
        </header>
      </div>
    );
}
  
  export default Australia;
  